import type {PlanProposal} from './planPackages.js'
import {PLAN_EXCLUSIONS} from './planPurchaseReview.js'

/** Catalog build proposal. Generated room imagery never determines price or scope. */
export const CASTLE_BUILD_PRICE = 149995;
export function castlePackage(plan: any, productLine: string, zip: string): PlanProposal | null {
  if (plan.layout?.bunkModelId !== 'castle') return null;
  if (productLine !== 'custom') throw Error('Castle belongs to Bliss Themes. Continue with its Custom proposal.');
  if (plan.layout?.rooms?.length || plan.layout?.configuratorSnapshot)
    throw Error('A Castle combined with other room layouts needs a confirmed combined proposal.');
  return {
    productLine:'custom',planId:plan.id,catalogModel:'castle',rooms:1,
    summary:'Castle · Bliss Themes',deliveryZip:zip,reasons:[],reviewItems:[],
    exclusions:[...PLAN_EXCLUSIONS],
    timing:['Installation is scheduled with you after design approval and fabrication. The balance is due before delivery and installation.'],
    packages:[{id:'castle',label:'Castle',total:CASTLE_BUILD_PRICE,recommended:true,scope:[
      'Castle themed bunk-room build',
      'Castle architectural detailing and circular reading turret',
      'Design and room measurements confirmed with you before fabrication',
      'Fabrication, finishing, delivery and professional installation',
      'Generated room décor and changes beyond the agreed Castle design are not included',
    ]}],
  };
}
